
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 81.771 81.771"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.885 0a40.885 40.885 0 1040.886 40.885A40.883 40.883 0 0040.885 0zm-8.177 57.243V24.531l25.554 16.354z"}})])
          )
        }
      }
    